<script>
    import { user } from '../../store'
    import CognitoAuth from '../../cognito/index.js'
    import { push } from 'svelte-spa-router'

    let error = ''
    let show = false

    const logIn = _ => {
        const cognito = new CognitoAuth()

        cognito.authenticate($user.username, $user.password, (err, result) => {
            if (err) error = err.message || err
            else error = '', push('/')
        })
    }

    const recoverPass = _ => push('/forgotPassword')

    const toggle = _ => {
        show = ! show
        document.getElementById('password').type = show ? 'text' : 'password'
    }
</script>

<div class="min-h-screen flex justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8 ">
        <div>
            <h2 class="mt-6 text-center text-3xl font-bold text-stone-900">
                Sign in
            </h2>
        </div>
        <div class="relative mt-10 h-px bg-gray-300">
            <div class="absolute left-0 top-0 flex justify-center w-full -mt-2">
                <span class="bg-white px-4 text-xs text-red-500 uppercase">
                    { error }
                </span>
            </div>
        </div>
        <form class="mt-8 space-y-6 " action="#" method="POST">
            <input type="hidden" name="remember" value="true">
            <div class="rounded-md">
                <div class="py-4" >
                    <label for="username" class="sr-only">Username:</label>
                    <div class="relative">
                        <div class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <input bind:value={$user.username} id="username" name="username" type="text" required class="rounded-md w-full  border border-gray-500 placeholder-stone-500 text-stone-900 pl-10 py-2 focus:outline-none focus:border-indigo-500" placeholder="Username">
                    </div>
                </div>
                <div class="py-4">
                    <label for="password" class="sr-only">Password</label>
                    <div class="relative">
                        <div class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>
                        <input bind:value={$user.password} id="password" name="password" type="password" required class="rounded-md w-full  border border-gray-500 placeholder-stone-500 text-stone-900 pl-10 py-2 focus:outline-none focus:border-indigo-500" placeholder="Password">

                        {#if show}
                            <div class="inline-flex items-center justify-center absolute right-0 top-0 h-full w-10 text-gray-400">
                                <svg on:click={toggle} xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                </svg>
                            </div>
                        {:else}
                            <div class="inline-flex items-center justify-center absolute right-0 top-0 h-full w-10 text-gray-400">
                                <svg on:click={toggle} xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>

            <div class="text-sm">
                <p on:click={recoverPass} class="font-medium text-indigo-600 hover:text-indigo-500 hover:underline cursor-pointer">
                    Forgot your password?
                </p>
            </div>

            <div>
                <button disabled={ !$user.username || !$user.password } on:click|preventDefault={ logIn } type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-base font-medium rounded-md bg-green-300 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400 ">
                      <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                        <svg class="h-5 w-5 text-emerald-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                        </svg>
                      </span>
                    Sign in
                </button>
            </div>
        </form>
    </div>
</div>
